import { render, staticRenderFns } from "./ViewPurchasesOrderComponent.vue?vue&type=template&id=f619277a&"
import script from "./ViewPurchasesOrderComponent.vue?vue&type=script&lang=js&"
export * from "./ViewPurchasesOrderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports